import { bindActionCreators } from 'redux';
import { connect, getActiveQuizSession, toggleSidebar as toggleSidebarAction, scrollToItem as scrollToItemAction, screenreaderNotification as screenreaderNotificationAction } from '@instructure/quiz-core';
import { GradingSidebar as Sidebar } from './presenter';
export var mapStateToProps = function mapStateToProps(state, props) {
  var quizSession = getActiveQuizSession(state);
  return {
    quizTitle: quizSession.getQuiz().title,
    sessionItems: quizSession.getSessionItems(),
    sessionNotLoaded: quizSession.id === '0',
    sidebarOpen: props.sidebarOpen || state.getIn(['sidebar', 'isOpen'])
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    scrollToItem: props.scrollToItem || bindActionCreators(scrollToItemAction, dispatch),
    toggleSidebar: props.toggleSidebar || bindActionCreators(toggleSidebarAction, dispatch),
    screenreaderNotification: bindActionCreators(screenreaderNotificationAction, dispatch)
  };
};
export var GradingSidebar = connect(mapStateToProps, mapDispatchToProps)(Sidebar);
export default GradingSidebar;